// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"496e1e87","787":"f8b35af0"}[chunkId] + ".chunk.js";
};